import React, { useState, useEffect } from 'react';
import Button from '../forms/buttons/Button';

import './Kit.assignPop.scss';
import {useTranslation} from "react-i18next";

function KitAssignPop({ kit, pop, handleClick }) {
    const {t} = useTranslation(['programs'])
    const [hasPopped, setHasPopped] = useState(false);
    useEffect(() => {
        if (pop && !hasPopped) {
            setHasPopped(true);
        }
    }, [pop, hasPopped]);
    const sendClick = () => {
        console.log('Pop clicked')
        if (!!handleClick) {
            handleClick()
        }
    }
    if (!!kit && kit.length) {
        return (
            <div className={`__KitAssignPop`}>
                <p className="centered">
                    {kit.length > 1 ? `${kit.length} kits` : `${kit[0]}`}
                </p>
            </div>
        )
    }
    return (
        <div className={`__KitAssignPop ${pop ? 'pop' : (hasPopped ? 'unPop' : '')}`}>
            <Button className={'pop'} disabled={!pop} handleClick={sendClick}>
                {t('assign-kit')}
            </Button>
        </div>
    )
}

export default KitAssignPop;